const REGIONAL_FREE_SHIPPING_THRESHOLD = 69900;
const REGIONAL_FREE_SHIPPING_THRESHOLD_CENTS = REGIONAL_FREE_SHIPPING_THRESHOLD * 100;
const RM_FREE_SHIPPING_THRESHOLD = 39900;
const RM_FREE_SHIPPING_THRESHOLD_CENTS = RM_FREE_SHIPPING_THRESHOLD * 100;

if (!customElements.get('free-shipping-progress')) {
  customElements.define(
    'free-shipping-progress',
    class FreeShippingProgress extends HTMLElement {
      connectedCallback() {
        this.thresholdCents = Number(this.dataset.threshold) || REGIONAL_FREE_SHIPPING_THRESHOLD_CENTS;
        this.rmThresholdCents = Number(this.dataset.rmThreshold) || RM_FREE_SHIPPING_THRESHOLD_CENTS;
        this.variant = this.dataset.variant || 'full';
        this.message = this.querySelector('[data-free-shipping-message]');
        this.badge = this.querySelector('[data-free-shipping-badge]');
        this.currentAmount = this.querySelector('[data-free-shipping-current]');
        this.track = this.querySelector('[data-free-shipping-track]');
        this.rmMilestone = this.querySelector('[data-free-shipping-rm-milestone]');
        this.regionalMilestone = this.querySelector('[data-free-shipping-regional-milestone]');

        this.render({
          total_price: Number(this.dataset.cartTotal) || 0,
          item_count: Number(this.dataset.cartItemCount) || 0,
        });

        this.onZhuvivaCartUpdate = (event) => {
          if (this.hasCompleteCartData(event.detail)) this.render(event.detail);
        };
        document.addEventListener('zhuviva:cart-updated', this.onZhuvivaCartUpdate);

        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, ({ cartData }) => {
            if (this.hasCompleteCartData(cartData)) {
              this.render(cartData);
              return;
            }

            this.fetchCart();
          });
        }

        if (this.variant === 'sticky') {
          this.updateStickyOffset = this.rafThrottle(this.setStickyOffset.bind(this));
          window.addEventListener('scroll', this.updateStickyOffset, { passive: true });
          window.addEventListener('resize', this.updateStickyOffset);
          this.setStickyOffset();
        }
      }

      disconnectedCallback() {
        this.cartUpdateUnsubscriber?.();
        document.removeEventListener('zhuviva:cart-updated', this.onZhuvivaCartUpdate);
        window.removeEventListener('scroll', this.updateStickyOffset);
        window.removeEventListener('resize', this.updateStickyOffset);
      }

      hasCompleteCartData(cartData) {
        return typeof cartData?.total_price === 'number' && typeof cartData?.item_count === 'number';
      }

      async fetchCart() {
        if (this.cartRequest) return this.cartRequest;

        this.cartRequest = fetch(`${window.routes.cart_url}.js`)
          .then((response) => {
            if (!response.ok) throw new Error(`Cart request failed: ${response.status}`);
            return response.json();
          })
          .then((cart) => this.render(cart))
          .catch((error) => console.error('Unable to update free shipping progress', error))
          .finally(() => {
            this.cartRequest = null;
          });

        return this.cartRequest;
      }

      render(cartData) {
        const safeTotalCents = Math.max(Number(cartData?.total_price) || 0, 0);
        const itemCount = Math.max(Number(cartData?.item_count) || 0, 0);
        const remainingCents = Math.max(this.thresholdCents - safeTotalCents, 0);
        const remainingForRmCents = Math.max(this.rmThresholdCents - safeTotalCents, 0);
        const progress = Math.min((safeTotalCents / this.thresholdCents) * 100, 100);
        const progressRounded = Math.round(progress);

        this.dataset.cartTotal = String(safeTotalCents);
        this.dataset.cartItemCount = String(itemCount);
        this.style.setProperty('--free-shipping-progress-value', `${progress}%`);
        this.badge.textContent = `${progressRounded}%`;
        this.track?.setAttribute('aria-valuenow', String(progressRounded));
        this.classList.toggle('is-rm-unlocked', safeTotalCents >= this.rmThresholdCents);
        this.classList.toggle('is-regional-unlocked', safeTotalCents >= this.thresholdCents);
        if (this.variant !== 'sticky') {
          if (this.rmMilestone) this.rmMilestone.textContent = safeTotalCents >= this.rmThresholdCents ? '✓' : '1';
          if (this.regionalMilestone) this.regionalMilestone.textContent = safeTotalCents >= this.thresholdCents ? '✓' : '2';
        }

        if (this.variant === 'sticky') {
          this.hidden = itemCount === 0;
          this.renderStickyMessage(remainingCents, remainingForRmCents, safeTotalCents);
          return;
        }

        if (this.currentAmount) this.currentAmount.textContent = this.formatCLP(safeTotalCents / 100);
        if (safeTotalCents >= this.thresholdCents) {
          this.message.innerHTML = '<strong>¡Envío GRATIS a todo Chile desbloqueado!</strong>';
        } else if (safeTotalCents >= this.rmThresholdCents) {
          this.message.innerHTML = `<strong>¡Envío GRATIS en RM!</strong> En Regiones desbloqueaste un gran descuento. Te faltan <strong>${this.formatCLP(remainingCents / 100)}</strong> para envío GRATIS a todo Chile.`;
        } else {
          this.message.innerHTML = `Te faltan <strong>${this.formatCLP(remainingForRmCents / 100)}</strong> para desbloquear envío GRATIS en RM y descuento en Regiones`;
        }
      }

      renderStickyMessage(remainingCents, remainingForRmCents, safeTotalCents) {
        if (safeTotalCents >= this.thresholdCents) {
          this.message.textContent = '¡Envío GRATIS a todo Chile desbloqueado!';
        } else if (safeTotalCents >= this.rmThresholdCents) {
          this.message.innerHTML = `<strong>¡Envío GRATIS en RM!</strong> En Regiones desbloqueaste un gran descuento. Te faltan <strong>${this.formatCLP(remainingCents / 100)}</strong> para envío GRATIS a todo Chile.`;
        } else {
          this.message.innerHTML = `Te faltan <strong>${this.formatCLP(remainingForRmCents / 100)}</strong> para desbloquear envío GRATIS en RM y descuento en Regiones`;
        }
      }

      setStickyOffset() {
        const header = document.querySelector('.section-header');
        if (!header) return;

        const rect = header.getBoundingClientRect();
        const isSticky = header.classList.contains('shopify-section-header-sticky');
        const offset = isSticky ? Math.max(0, rect.bottom) : 0;
        this.style.setProperty('--free-shipping-sticky-top', `${offset}px`);
      }

      rafThrottle(callback) {
        let scheduled = false;
        return () => {
          if (scheduled) return;
          scheduled = true;
          window.requestAnimationFrame(() => {
            callback();
            scheduled = false;
          });
        };
      }

      formatCLP(value) {
        return `$${Math.round(value).toLocaleString('es-CL')}`;
      }
    }
  );
}
